import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import { cloneDeep, zipObject, isEqual } from '../../utils/lodash';
import produce from 'immer';

import { Paper, Button, Popover, Table, TableBody, TablePagination } from '@mui/material';

import {
  Add,
  SortByAlpha,
  FilterListOutlined,
  DragHandleOutlined,
  VisibilityOffOutlined,
  CloudDownloadOutlined,
  KeyboardArrowUpOutlined,
  KeyboardArrowDownOutlined,
} from '@mui/icons-material';

import Filters from '../Filters';
import Sorters from '../Sorters';
import Switcher from '../Switcher';
import LoaderNew from '../LoaderNew';
import CommonStyles from '../CommonStyles';
import ComponentWrapper from '../ComponentWrapper';
import AnimatedButton from '../AnimatedSavingBtn';

import TrplForm from '../TrplForm/TrplForm';
import TrplFormFullScreenDialog from '../TrplForm/TrplFormFullScreenDialog';
import TrplRenderPartsModal from '../TrplForm/TrplRenderPartsModal';

import TrplsTableStyles from './TrplsTableStyles';
import TrplsTableRow from './components/TrplsTableRow';
import TrplsTableHeadRow from './components/TrplsTableHeadRow';

import {
  getTransformedNodesArrayToObj,
  getTransformedTrplsArrayToObj,
  findLastRstInPredicateChain,
  decodeFilterFromUrl,
  getPidsFromShowPids,
  encodeFilterForUrl,
  generateFilter,
  getUrlParameter,
  isFilterHasValues,
  isNotPlaceholderFilter,
  isNotSearchFilter,
  removeUrlParameter,
  setUrlParameter,
  getChainTitle,
  extractPidValue,
  trplsParamsTable,
  prdcParamsTable,
  boxParamsTable,
  isJsonObject,
  nodesParams,
  getColumnTitle,
  getColumnId,
  getNodeColor,
} from '../../utils';

import ArrowTooltipCss from '../ArrowTooltipCss';

import { updateJelsFromGetView, getJelData } from '../../reducer/jelsReducer';

const styles = { ...CommonStyles, ...TrplsTableStyles };

document.body.style.backgroundColor = '#fff';

class TrplsTable extends ComponentWrapper {
  state = {
    account: {
      offset: 0,
    },
    rowBorderBold: false,
    init: true,
    individuals: {
      trpls: {},
      nodes: [],
      query: [],
      concepts: [],
      total_query: 0,
      pagination_end: false,
    },
    restrictions: [],
    trplFormModalShowPids: [],
    trplFormModalOpened: false,
    renderPartsModalOpened: false,
    trplFormModal: {
      mode: 'create',
      tabs: [],
      node: {},
      rst: {},
      trpl: {},
    },
    filterRstModal: {
      rst: {
        id: '',
        title: '',
      },
      trpls: {},
      isOpened: false,
    },
    searchValue: '',
    rowsToShow: 50,
    rowsToShowPage: 1,
    rowsToShowSteps: [50, 100, 150, 200, 250, 500],
    isDataLoaded: false,
    tableMenu: {
      filters: {
        el: null,
        trpls: [],
        initialFilters: [],
      },
      sorter: {
        el: null,
        data: {
          sortBy: 1,
          sort_pid: null,
        },
      },
      hideColumn: {
        el: null,
        data: [],
      },
      export: {
        el: null,
        extension: null,
      },
      tableHead: {
        el: null,
        rstIndex: null,
      },
      actions: {
        el: null,
      },
    },
    actions: {
      count: 0,
      variants: [],
      sending: false,
    },
    scrolled: false,
    selectedRows: [],
    isTableFiltered: true,
    tableId: 0,
    tableSettings: {},
    tableLayout: '',
    clickCountForAllOnt: 0,
    isHiddenAllOnt: true,
    allOntNodes: false,
  };

  componentDidMount() {
    const { isEmbed, settings, jels } = this.props;
    let { show_pids, rowsToShow, column_titles=[], title } = settings;

    if (!isEmbed && title) document.title = `${title} | Milkyweb`;

    const ancestorId = settings.concept || 0;
    const tableId = settings.id || settings.concept || 0;

    // Handle bold rows from localStorage
    let rowBorderBold = false;
    if (tableId && tableId !== 0) {
      const boldFromLocalStorage = localStorage.getItem(`b.${tableId}`);
      if (settings.hasOwnProperty('bold_rows') && boldFromLocalStorage === null) {
        this.onRowsWeightChange(settings.bold_rows);
      } else if (boldFromLocalStorage !== null) {
        rowBorderBold = boldFromLocalStorage;
      }
    }

    // Parse show_pids from URL
    if (!show_pids) {
      show_pids = [];
      const tempShowPidsFromUrl = getUrlParameter('show_pids');

      if (tempShowPidsFromUrl) {
        show_pids = tempShowPidsFromUrl.split(',').map(pid => +pid);
      }
    }

    // Get search value from URL
    const searchValue = getUrlParameter('search_query') || '';

    // update default forms
    const formsInRedux = jels.forms;
    const defaultFormsIds = jels && jels.defaultForms && jels.defaultForms.reduce((arr, defaultJel) => {
      if (formsInRedux.includes(+defaultJel.form)) return arr;
      return [ ...arr, defaultJel.form ];
    }, []);

    if (defaultFormsIds && defaultFormsIds.length) this.props.getJelData(defaultFormsIds);

    // Update state
    this.setState({
      tableId,
      ancestorId,
      searchValue,
      rowBorderBold,
      tableSettings: settings,
      rowsToShow: rowsToShow !== undefined ? rowsToShow : this.state.rowsToShow,
      rowsToShowSteps: rowsToShow && !this.state.rowsToShowSteps.includes(rowsToShow) ? [rowsToShow, ...this.state.rowsToShowSteps] : this.state.rowsToShowSteps,
    }, () => {
      const { tableStartLoadCb, tableEndLoadCb } = this.props;

      if (tableStartLoadCb) tableStartLoadCb();

      this.getIndividuals(individuals => {
        // Prepare data and update state
        const { restrictions, tableMenuRstsData, actionsVariants } = prepareShowPids(individuals, ancestorId);
        const actions = { variants: actionsVariants || [] };
        const tableMenuCopy = cloneDeep(this.state.tableMenu);

        if (this.props.show_pids && Array.isArray(this.props.show_pids) && !this.props.show_pids.length) {
          const arr = [];

          restrictions.forEach((rst) => {
            const rstChainId = getColumnId(rst);
            arr.push(rstChainId);
          });

          tableMenuCopy.hideColumn.data = arr;
        }

        // Update tableMenu filters
        tableMenuCopy.filters.rstDataMap = new Map(
          tableMenuRstsData.filter(rst => rst.type && rst.type !== 'BUTTON')
            .map(rst => [rst.chainTitle || String(rst.id), { ...rst }])
        );

        const filtersFromUrl = getUrlParameter('filters');
        const filtersData = filtersFromUrl && JSON.parse(filtersFromUrl);

        if (filtersData) {
          filtersData.forEach((filter) => {
            tableMenuCopy.filters.initialFilters.push({ ...filter });
          });

          tableMenuCopy.filters.trpls = filtersData;

          if (searchValue) {
            tableMenuCopy.filters.trpls = filtersData.map(filter => {
              if (isNotSearchFilter(filter)) return filter;

              return { ...filter, val: searchValue }
            });
          }
        }

        // Update tableMenu sorter
        const sorterFromSettings = settings.sort_pid
          ? {
              sort_pid: settings.sort_pid,
              sort_desc: settings.sort_desc,
              sort_by: settings.sort_by,
            }
          : null;

        if (!isEmbed && sorterFromSettings) setUrlParameter('sorter', JSON.stringify(sorterFromSettings));

        const sorterFromUrl = getUrlParameter('sorter') ? JSON.parse(getUrlParameter('sorter')) : sorterFromSettings;

        if (sorterFromUrl)
          tableMenuCopy.sorter.data = {
            sort_pid: sorterFromUrl.sort_pid,
            sort_desc: sorterFromUrl.sort_desc,
            sort_by: sorterFromUrl.sort_by !== undefined ? +sorterFromUrl.sort_by : 1,
          };

        this.setState({
          actions,
          individuals,
          init: false,
          restrictions,
          isDataLoaded: true,
          isTableFiltered: true,
          tableMenu: tableMenuCopy,
          account: this.props.account,
        }, () => {
          // Add scroll listener after state is updated
          const table = document.querySelector('.trpls-table-container');//this.tableRef.current; // Assuming tableRef is a React ref

          if (table) {
            table.addEventListener('scroll', () => {
              if (table.scrollTop === 0) {
                this.setState({ scrolled: false });
              } else if (!this.state.scrolled) {
                this.setState({ scrolled: true });
              }
            });
          }

          if (tableEndLoadCb) tableEndLoadCb();
        });
      });
    });

    // Set interval for updating data if isEmbed and update_table_period is provided
    let intervalId;
    if (isEmbed && settings.update_table_period) {
      intervalId = setInterval(this.updateData, settings.update_table_period);
      this.setState({ intervalId });
    }

    const getZippedBox = this.getZippedBox;

    function prepareShowPids(individuals, ancestor) {
      const zippedBox = individuals.nodes && individuals.nodes[ancestor] ? zipObject(boxParamsTable, individuals.nodes[ancestor].box) : {};
      const concepts = (zippedBox && zippedBox.r) || {};

      if (!concepts) {
        return { restrictions: [], showPidsIds: [] };
      }

      const tboxKeys = zippedBox && zippedBox.t_supers_implicit ? [...zippedBox.t_supers_implicit, ancestor] : [ancestor];

      const restrictions = [];
      const actionsVariants = [];
      const tableMenuRstsData = [];

      if (show_pids && show_pids.length) {
        show_pids.forEach((showPidEl, showPidIndex) => {
          if (Array.isArray(showPidEl) && isJsonObject(showPidEl[0])) {
            const newColumn = showPidEl.map((rowObj, index) => {
              const foundRst = findLastRstInPredicateChain(rowObj.pids, individuals, ancestorId, prdcParamsTable, boxParamsTable);
              const chainTitle = Array.isArray(rowObj.pids) && rowObj.pids.length > 1 ? rowObj.pids.join('.') : rowObj.pids;

              if (foundRst) {
                const rstForMenu = { ...foundRst, chainTitle };
                tableMenuRstsData.push(rstForMenu);
              }

              const newRowObj = {
                ...rowObj,
                foundRst,
                chainTitle,
                title: getChainTitle(rowObj.pids, ancestor, individuals.nodes, prdcParamsTable, boxParamsTable),
              }
              if (index === 0) newRowObj.column_title = column_titles[showPidIndex]
              if (rowObj.obj_editable_frm) newRowObj.obj_editable_frm = rowObj.obj_editable_frm
              return newRowObj;
            });
            restrictions.push(newColumn);

          } else if (isJsonObject(showPidEl) && showPidEl.type === 'custom') {
            const usedPids = []
            const customPidData = showPidEl.custom_pid
              ? findLastRstInPredicateChain(showPidEl.custom_pid, individuals, ancestorId, prdcParamsTable, boxParamsTable) : null;
            const newColumn = {
              ...showPidEl,
              usedPids,
              custom_component: showPidEl.custom_component.map(row => {
                const newRowChildren = row.children.map(column => {
                  const newColumnChildren = column.children.map(comp => {
                    if (comp.type === 'text') {
                      if (comp.value) {
                        const pidVal = extractPidValue(comp.value);
                        const foundRst = pidVal ? findLastRstInPredicateChain(+pidVal, individuals, ancestorId, prdcParamsTable, boxParamsTable) : null;
                        if (foundRst) restrictions.push(foundRst);
                      }
                      return comp;
                    } else {
                    const pidsToChain = showPidEl.custom_pid ? [...showPidEl.custom_pid, ...comp.pids] : comp.pids;
                    const foundRst = findLastRstInPredicateChain(pidsToChain, individuals, ancestorId, prdcParamsTable, boxParamsTable);
                    const chainTitle = Array.isArray(pidsToChain) && pidsToChain.length > 1 ? pidsToChain.join('.') : pidsToChain;

                    if (showPidEl.custom_pid && customPidData) {
                      foundRst.complicated_title = `${customPidData.title}.${foundRst.title}`
                    } 

                    if (foundRst) {
                      const rstForMenu = {
                        ...foundRst,
                        chainTitle,
                        title: showPidEl.custom_pid && customPidData ? foundRst.complicated_title : foundRst.title,
                      };
                      tableMenuRstsData.push(rstForMenu);
                    }

                    if (usedPids.findIndex(item => JSON.stringify(item.id) === JSON.stringify(foundRst.id)) === -1)
                      usedPids.push({ ...foundRst, chain: pidsToChain, chainTitle });
                      const newComp = {
                        ...foundRst,
                        originalPid: comp.pids,
                        compType: comp.type,
                        title: foundRst.title,
                        renderer: comp.renderer,
                        chainTitle,
                      }
                      if (comp.obj_editable_frm) newComp.obj_editable_frm = comp.obj_editable_frm;
                    return newComp;
                    }
                  });
                  return { ...column, children: newColumnChildren };
                });
              return { ...row, children: newRowChildren };
            })};
            restrictions.push({ column_title: column_titles[showPidIndex], ...newColumn});

          } else {
            const pids = getPidsFromShowPids(showPidEl);

            if (pids) {
              const foundRst = findLastRstInPredicateChain(pids, individuals, ancestorId, prdcParamsTable, boxParamsTable);
              const chainTitle = Array.isArray(pids) && pids.length > 1 ? pids.join('.') : pids;

              if (foundRst) {
                const rstForMenu = { ...foundRst, chainTitle };
                tableMenuRstsData.push(rstForMenu);
              }

              const newColumn = {
                ...foundRst,
                chainTitle,
                title: Array.isArray(pids) ? getChainTitle(pids, ancestor, individuals.nodes, prdcParamsTable, boxParamsTable) : foundRst ? foundRst.title : '',
                column_title: column_titles[showPidIndex],
              }
              if (showPidEl.obj_editable_frm) newColumn.obj_editable_frm = showPidEl.obj_editable_frm;
              newColumn.editable = showPidEl.hasOwnProperty('editable') ? showPidEl.editable : true;
              if (showPidEl.renderer) newColumn.renderer = showPidEl.renderer;
              if (showPidEl.title) newColumn.nodeBtnTitle = showPidEl.title;
              restrictions.push(newColumn);
            } else {
              const newColumn = { column_title: column_titles[showPidIndex] };
              if (showPidEl.obj_editable_frm) newColumn.obj_editable_frm = showPidEl.obj_editable_frm;
              if (showPidEl.title) newColumn.nodeBtnTitle = showPidEl.title;

              restrictions.push(newColumn);
            }
          }
        });
      } else {
        tboxKeys.forEach((conceptKey) => {
          if (concepts[conceptKey])
            concepts[conceptKey].forEach((rstArray) => {
              let rst = zipObject(prdcParamsTable, rstArray);
              rst.editable = true;
              tableMenuRstsData.push(rst);
              restrictions.push(rst);
            });
        });
      }

      restrictions && restrictions.length && restrictions.forEach((rst) => {
        if (rst.type === 'BUTTON') actionsVariants.push(rst);
      });

      return { restrictions, tableMenuRstsData, actionsVariants };
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.callbacks && this.props.callbacks.getSelecteRowsNodes) {
      this.props.callbacks.getSelecteRowsNodes(this.state.selectedRows);
    }
    if (this.state.restrictions && this.state.restrictions.length && !this.state.tableLayout) {
      // should be setted after each HighlightedTableCell have saved offsetWidth 
      this.setState({ tableLayout: 'fixed' });
    }
    if (this.props.forceUpdateTable !== prevProps.forceUpdateTable) this.updateData();

    const rows = document.querySelectorAll('.MuiTableRow-root');
    rows.forEach(row => {
      let h = row.clientHeight;
      if (h < 25) h = 25;
      if (h % 1 !== 0) {
        row.style.height = `${Math.round(h)}px`;
      }
    });
  };

  componentWillUnmount() {
    const { intervalId } = this.state;
    if (intervalId) clearInterval(intervalId);
  };

  setSorter = (sorter, cb) => {
    const { init } = this.state;

    const newTableMenu = produce(this.state.tableMenu, tableMenuCopy => {
      tableMenuCopy.sorter.data = { ...sorter };
    });

    this.setState({ tableMenu: newTableMenu }, () => {
      const { isEmbed } = this.props;

      if (!init && !isEmbed) {
        if (sorter && sorter.sort_pid) {
          setUrlParameter('sorter', JSON.stringify(sorter));
        } else {
          removeUrlParameter('sorter');
        }
      }

      if (cb) cb();
    });
  };

  onSorterClick = (params) => {
    const { isEmbed } = this.props;
    const { sort_pid, sort_desc, sort_by } = params;

    let newSorter = {
      sort_pid: Array.isArray(sort_pid) && sort_pid.length > 1 ? sort_pid.join('.')
        : Array.isArray(sort_pid) ? sort_pid[0] : sort_pid || '',
      sort_by: sort_by !== undefined ? sort_by : 1,
      sort_desc: sort_desc !== undefined ? sort_desc : false,
    };

    if (!isEmbed) {
      this.setState({ isDataLoaded: false }, () => {
        this.setSorter(newSorter, () => {
          this.getIndividuals((individuals) => {
            this.setState({
              individuals,
              rowsToShowPage: 1,
              isDataLoaded: true,
            });
          });
        });
      });
    } else {
      this.setSorter(newSorter, () => {
        this.updateData();
      });
    }
  };

  openTrplFormFull = (params) => {
    const { node, mode, initialNodeId, obj_editable_frm } = params;
    const { trplFormModal } = this.state;
    const { settings, jels } = this.props;

    let formId;
    if (obj_editable_frm) {
      formId = obj_editable_frm;
    } else formId = settings.buttons && settings.buttons.editNode;

    const form = formId && jels.jelData && jels.jelData[formId];

    if (initialNodeId) trplFormModal.initialNodeId = initialNodeId;

    trplFormModal.id = formId;
    trplFormModal.node = node;
    trplFormModal.mode = mode;
    trplFormModal.title = form ? form.title : 'Edit';

    if (form) {
      trplFormModal.tabs = form && jels.jelData[formId].tabsTitles ? jels.jelData[formId].tabsTitles : [];
    }

    this.setState(
      {
        trplFormModal,
      },
      () => {
        this.setState({
          trplFormModalOpened: true,
        });
      }
    );
  };

  shouldComponentUpdate = (nextProps, nextState) => {
    const currentQuery = this.props.preloadedData && this.props.preloadedData.query;
    const nextQuery = nextProps.preloadedData && nextProps.preloadedData.query;
    
    const shouldUpdate = () => {
      return (
        this.state !== nextState ||
        this.state.allOntNodes !== nextState.allOntNodes ||
        !isEqual(this.props.nodeToHighlight, nextProps.nodeToHighlight) ||
        this.props.forceUpdateTable !== nextProps.forceUpdateTable ||
        (currentQuery && nextQuery && !isEqual(currentQuery, nextQuery))
      )
    };

    if (!shouldUpdate()) return false;
    return true;

    // return ((this.state !== nextState) ||
    //   !isEqual(this.props.nodeToHighlight, nextProps.nodeToHighlight) ||
    //   (this.props.forceUpdateTable !== nextProps.forceUpdateTable) ||
    //   (this.props.preloadedData && this.props.preloadedData.query && nextProps.preloadedData && nextProps.preloadedData.query &&
    //      !isEqual(this.props.preloadedData.query, nextProps.preloadedData.query)));
  };

  // shouldComponentUpdate = (nextProps, nextState) => {
  //   return ((this.state.tableLayout !== nextState.tableLayout) ||
  //   (this.state.individuals !== nextState.individuals) ||
  //   (this.state.isDataLoaded !== nextState.isDataLoaded) ||
  //   (this.state.rowBorderBold !== nextState.rowBorderBold) ||
  //   (this.state.trplFormModalOpened !== nextState.trplFormModalOpened) ||
  //   (this.state.selectedRows.length !== nextState.selectedRows.length) ||
  //   (this.state.tableMenu.filters.isDataLoaded !== nextState.tableMenu.filters.isDataLoaded) ||
  //   !isEqual(this.state.tableMenu, nextState.tableMenu));
  // };

  closeRenderPartsModal = () => {
    this.setState({
      renderPartsModalOpened: false,
    });

    this.updateData();
  };

  getIndividuals = (cb) => {
    const { searchValue, init, tableMenu, rowsToShow, rowsToShowPage, allOntNodes } = this.state;
    const { concept, id } = this.props.settings;

    const { settings, setup, jels } = this.props;

    const data = {
      api_key: setup.id,
      filter: {},
      sorter: {
        sort_pid: '',
        sort_by: '',
      },
    };

    if (concept) data.filter.ancestor = concept;
    const tableId = id ? id : settings.tableId;
    if (tableId) data.id = tableId;

    const sorterFromSettings = {
      sort_by: settings.sort_by,
      sort_pid: settings.sort_pid,
      sort_desc: settings.sort_desc,
    };

    // set sorters
    const sorterFromUrl = getUrlParameter('sorter');

    const sorter = init && sorterFromUrl ? JSON.parse(sorterFromUrl) : init ? sorterFromSettings : tableMenu.sorter.data;

    if (sorter.sort_by !== undefined) data.sorter.sort_by = sorter.sort_by;
    if (sorter.sort_pid !== undefined) data.sorter.sort_pid = sorter.sort_pid;
    if (sorter.sort_desc !== undefined) data.sorter.sort_desc = sorter.sort_desc;

    if (searchValue.length) data.filter.search_query = searchValue;

    // set filters
    const filtersFromUrl = getUrlParameter('filters');
    
    const filters = filtersFromUrl
      ? JSON.parse(filtersFromUrl).map(decodeFilterFromUrl)
      : tableMenu.filters.trpls;

    // encode filters for request
    data.filter.trpls = [];
    if (filters) {
      data.filter.trpls =
        filters
          .filter(isNotSearchFilter)
          .filter(isNotPlaceholderFilter)
    }
    if (!data.filter.limit) data.filter.limit = rowsToShow;
    if (!data.filter.page) data.filter.page = rowsToShowPage;

    const dataFetchingCallback = (res) => {
      if (cb) cb(res);
    };

    const { preloadedData, usePreloadedQuery } = this.props;
    const { updateFilter, initialViewId } = this.props;

    if (updateFilter) {
      if (data.filter && typeof data.filter === 'object' && Object.values(data.filter).length) data.filter = { ...data.filter, ...updateFilter };
      else data.filter = updateFilter;
    }
    
    const isViewInRedux = jels && jels.tables.includes(id);

    if (usePreloadedQuery) {
      if (!preloadedData.query || (Array.isArray(preloadedData.query) && !preloadedData.query.length)) {
        
        dataFetchingCallback(preloadedData);
        return;
      }

      data.filter.nodes = preloadedData.query;
      if (settings.trpl_filter) data.filter.trpls = settings.trpl_filter;
    }

    if (allOntNodes) data.filter.skip_ontologies = true;

    data.render = {
      trpl:{
        type:"a",
        params: trplsParamsTable,
      },
      node:{
        type:"a",
        params: nodesParams,
      },
      prdc:{
        type:"a",
        params: prdcParamsTable,
      },
      box:{
        type:"a",
        params: boxParamsTable,
      },
      jels:!isViewInRedux,
    };

    let urlToPost = settings.type === 'table' ? `/rest/get_view` : '/pnkqry3';

    if (settings.type === 'table') {
      if (initialViewId && initialViewId !== data.id) data.initial_view = initialViewId;
    }

    if (!usePreloadedQuery && init && preloadedData) {
      dataFetchingCallback(preloadedData);
    } else {
      this.postWithData({
        url: urlToPost,
        data,
        cb: (res) => {
          if (res && res._status === 'ok') {
            if (res.jels) this.props.updateJelsFromGetView(res.jels);
            
            res.nodes = getTransformedNodesArrayToObj(res.nodes, nodesParams);
            dataFetchingCallback(res);
          } else {
            this.setState({
              isTableFiltered: true,
              isDataLoaded: true
            });
          }
          if (this.props.callbacks && this.props.callbacks.setUpdatedTableData) this.props.callbacks.setUpdatedTableData(res._status, res);
        },
        errorCb: () => {
          this.setState({
            isTableFiltered: true,
            isDataLoaded: true
          });
        },
      });
    }
  };

  onNodeRemoveBtnClick = (nodeId, rstId, trplId) => {
    let { individuals } = this.state;
    const cont = this;

    this.get({
      url: `/rest/del_trpl?id=${trplId}`,
      cb: () => {
        const rst = individuals.trpls[nodeId][rstId];

        if (Array.isArray(rst)) {
          const filteredTrpls = rst.filter((trpl) => {
            let zippedTrpl = zipObject(trplsParamsTable, trpl);
            return zippedTrpl.tid !== trplId;
          });

          individuals.trpls[nodeId][rstId] = filteredTrpls;
        } else {
          delete individuals.trpls[nodeId][rstId];
        }

        cont.setState({ individuals });
      },
    });
  };

  onExportClick = (extension) => {
    const { searchValue, rowsToShow, rowsToShowPage, tableMenu } = this.state;
    const { concept, sort_by, sort_pid, id } = this.props.settings;
    const { setup } = this.props;

    const data = {
      api_key: setup.id,
      nesting: 2,
      filter: {
        ancestor: `${concept}`,
        page: rowsToShowPage,
        limit: rowsToShow,
      },
      sorter: {
        sort_pid: sort_pid || '',
        sort_by: sort_by || '',
      },
    };

    if (id) data.tbl = id;

    if (tableMenu.sorter.data.sort_desc !== undefined) {
      data.sorter.sort_pid = tableMenu.sorter.data.sort_pid;
      data.sorter.sort_by = tableMenu.sorter.data.sort_by;
      data.sorter.sort_desc = tableMenu.sorter.data.sort_desc;
    }

    if (searchValue.length) {
      data.filter.search_query = searchValue;
    }

    if (tableMenu.filters.trpls) {
      data.filter.trpls = tableMenu.filters.trpls
        .filter(isNotPlaceholderFilter)
        .filter(isNotSearchFilter)
        .filter(isFilterHasValues);
    }

    const downloadLink = document.querySelector('.download-tbl');

    downloadLink.href = `/export_tbl?data=${JSON.stringify(data)}&ext=${extension}`;
  };

  goToPage = (rowsToShowPage, disableScroll) => {
    this.setState({ isDataLoaded: false }, () => {
      let { rowsToShow } = this.state;

      this.setState({ rowsToShow, rowsToShowPage }, () => {
        this.updateData(() => {
          const { isEmbed } = this.props;

          if (!isEmbed && !disableScroll) {
            this.mainContainer.scrollTo(0, 0);
          } else {
            const { tableEndLoadCb, groupContainerClassName } = this.props;

            if (tableEndLoadCb) tableEndLoadCb();

            const container = document.querySelector(`.${groupContainerClassName}`);

            if (container) container.scrollTo(0, 0);
          }

          this.fixIndexCellWidth();
        });
      });
    });
  };

  getZippedBox = (individuals, ancestor) => {
    const zippedBox = individuals.nodes && individuals.nodes[ancestor] ? zipObject(boxParamsTable, individuals.nodes[ancestor].box) : {};

    return zippedBox;
  };

  openTrplFormWithRst = (node, rst, trpl) => {
    const obj = {
      trplFormModal: {
        mode: 'edit',
        rst,
        node,
        groups: [],
      },
    };

    let modalKey = 'renderPartsModalOpened';

    if (trpl) obj.trplFormModal.trpl = trpl;

    if (rst.render_parts) {
      const { individuals } = this.state;

      const trpl =
        individuals.trpls[node.id] && individuals.trpls[node.id][rst.id] ? individuals.trpls[node.id][rst.id] : null;

      if (trpl) obj.trplFormModal.trpl = trpl;
    } else {
      obj.trplFormModalShowPids = [rst.id];
      modalKey = 'trplFormModalOpened';
    }

    obj[modalKey] = true;

    this.setState(obj);
  };

  updateData = (cb) => {
    const { tableStartLoadCb, tableEndLoadCb } = this.props;

    if (tableStartLoadCb) tableStartLoadCb();

    const endCb = cb || tableEndLoadCb;

    this.getIndividuals((newData) => {
      const mergedNodes = { ...this.state.individuals.nodes, ...newData.nodes };
      const mergedIndividuals = { ...newData, nodes: mergedNodes };

      this.setState({
        individuals: mergedIndividuals,
        isTableFiltered: true,
        isDataLoaded: true
      }, () => {
        if (endCb) endCb();
      });
    });
  };

  closeTrplFormModal = () => {
    let { trplFormModal } = this.state;
    const { closeModalCb } = this.props;

    trplFormModal = {
      mode: 'create',
      node: {},
      rst: {},
      tabs: [],
      trpl: {},
      groups: [],
    };

    this.setState({
      trplFormModal,
      trplFormModalOpened: false,
      trplFormModalShowPids: [],
    });

    if (closeModalCb) closeModalCb();
    this.updateData();
  };

  onRstTypeBtnClick = (rstId, nodeId) => {
    const { tableStartLoadCb, tableEndLoadCb } = this.props;

    this.setState({ isDataLoaded: false });

    if (tableStartLoadCb) tableStartLoadCb();

    this.postWithData({
      url: `/rest/run_macros`,
      data: {
        pid: rstId,
        eid: nodeId,
      },
      cb: () => {
        this.getIndividuals((individuals) => {
          this.setState({ individuals, isDataLoaded: true }, () => {
            if (tableEndLoadCb) tableEndLoadCb();
          });
        });
      },
    });
  };

  togglePopover = (value, key, rstId) => {
    const tableMenu = { ...this.state.tableMenu };
    const tableMenuChild = { ...tableMenu[key] };

    tableMenuChild.el = value;

    if (rstId && value) {
      tableMenu.rstId = rstId;
    } else if (rstId && !value) {
      tableMenu.rstId = null;
    }

    tableMenu[key] = tableMenuChild;

    this.setState({ tableMenu });
  };

  onFilterSearchElemClick = (node) => {
    const individuals = { ...this.state.individuals };

    if (!individuals.nodes[node.id]) {
      const nodes = { ...individuals.nodes };

      nodes[node.id] = node;
      individuals.nodes = nodes;

      this.setState({ individuals });
    }
  };

  setFiltersToState = (filters) => {
    const tableMenu = { ...this.state.tableMenu };
    const tableMenuFilters = { ...tableMenu.filters };

    tableMenuFilters.trpls = filters.map(filter => ({ ...filter }));
    tableMenuFilters.initialFilters = [...filters];

    tableMenu.filters = tableMenuFilters;

    this.setState({ tableMenu });
  };

  onFilterBtnClick = (filters, sValue) => {
    const { searchFilterInputFocused } = this.state;

    if (searchFilterInputFocused) return;

    const { isEmbed } = this.props;
    const tableMenuCopy = cloneDeep(this.state.tableMenu);

    this.setState({ tableMenu: tableMenuCopy, isTableFiltered: false }, () => {
      const newTrpls = filters.map(filter => ({ ...filter }));

      let isNeedGoToFirstPage = false;
      const { rowsToShowPage } = this.state;

      const filtersTrplsStr = JSON.stringify(newTrpls);

      tableMenuCopy.filters.initialFilters = filters;
      tableMenuCopy.filters.trpls = newTrpls;

      // TODO I believe there is something wrong 
      if (rowsToShowPage > 0) {
        const filtersFromUrl = getUrlParameter('filters');

        if (filtersFromUrl !== filtersTrplsStr) isNeedGoToFirstPage = true;
      }

      if (!isEmbed) {
        const filtersForUrl = [
          ...tableMenuCopy.filters.trpls
            .filter(isNotSearchFilter)
            .filter(isNotPlaceholderFilter)
            .map(encodeFilterForUrl)
        ];

        if (filtersForUrl.length) {
          setUrlParameter('filters', JSON.stringify(filtersForUrl));
        } else {
          removeUrlParameter('filters');
        }

        if (sValue) {
          setUrlParameter('search_query', sValue);
        } else {
          removeUrlParameter('search_query');
        }
      }

      this.setState({ searchValue: sValue || '', tableMenu: tableMenuCopy }, () => {
        if (isNeedGoToFirstPage) {
          this.goToPage(1);
        } else {
          this.updateData();
        }
      });
    });
  };

  searchFilterInputOnFocus = (searchFilterInputFocused) => {
    this.setState({ searchFilterInputFocused });
  };

  toggleColumn = (rstId) => {
    const { tableMenu } = this.state;

    const arr = [...tableMenu.hideColumn.data];

    const isAlreadyInArr = arr.includes(rstId);

    if (!isAlreadyInArr) {
      arr.push(rstId);
    } else {
      const index = arr.indexOf(rstId);

      if (index !== -1) arr.splice(index, 1);
    }

    tableMenu.hideColumn.data = arr;

    this.setState({ tableMenu });
  };

  rstAddFilterClick = (rstId, val, cb) => {
    // TODO fix logic duplication here and on onFilterChange in Filters
    const tableMenu = { ...this.state.tableMenu };
    const tableMenuFilters = { ...tableMenu.filters };

    tableMenuFilters.initialFilters = [
      ...tableMenuFilters.initialFilters, generateFilter(rstId, val, '')
    ];

    tableMenu.filters = tableMenuFilters;

    this.setState({ tableMenu }, () => {
      cb();
    });
  };

  toggleAllColumns = (visible) => {
    const { restrictions, tableMenu } = this.state;

    if (visible) {
      const arr = [];

      restrictions.forEach((rst) => {
        const rstChainId = getColumnId(rst);
        arr.push(rstChainId);
      });

      tableMenu.hideColumn.data = arr;
    } else {
      tableMenu.hideColumn.data = [];
    }

    this.setState({ tableMenu });
  };

  selectNode = (checked, nodeId) => {
    const { selectedRows, individuals } = this.state;

    let selectedRowsCopy = [...selectedRows];

    if (nodeId === 'all') {
      if (checked) {
        let addedRows = selectedRowsCopy.concat(individuals.query);
        selectedRowsCopy = Array.from(new Set(addedRows));
      } else {

        let positiveArr = selectedRowsCopy.filter(function(row) {
          return individuals.query.includes(row);
        });
        selectedRowsCopy = selectedRowsCopy.filter(item => !positiveArr.includes(item));
      }
    }
    
    if (nodeId !== 'all') {
      if (checked) {
        selectedRowsCopy.push(nodeId);
      } else {
        const index = selectedRowsCopy.indexOf(nodeId);

        if (index !== -1) selectedRowsCopy.splice(index, 1);
      }
    }

    this.setState({ selectedRows: selectedRowsCopy });
  };

  doActions = (rstId, title) => {
    const { actions, tableMenu, selectedRows } = this.state;

    actions.title = title;
    actions.sending = true;

    tableMenu.actions.el = null;

    const nodes = [...selectedRows];

    actions.totalCount = nodes.length;

    this.setState({ actions }, () => {
      this.sendAction(rstId, 0, nodes);
    });
  };

  sendAction = (rstId, index, nodes) => {
    const { actions } = this.state;

    const nodeId = nodes[index];

    if (actions.sending && index <= nodes.length - 1) {
      this.postWithData({
        disableNotify: true,
        url: `/rest/run_macros`,
        data: {
          pid: rstId,
          eid: nodeId,
        },
        cb: () => {
          const { actions, selectedRows } = this.state;

          actions.count++;

          const selectedRowsCopy = [...selectedRows];
          selectedRowsCopy.shift();

          if (index === nodes.length - 1) {
            this.setState({ isDataLoaded: false }, () => {
              this.updateData(() => {
                const { actions } = this.state;

                actions.count = 0;
                actions.title = '';
                actions.totalCount = 0;
                actions.sending = false;

                this.setState(
                  {
                    selectedRows: selectedRowsCopy,
                    actions,
                    isDataLoaded: true,
                  },
                  () => {
                    this.notify('success', 'Done');
                  }
                );
              });
            });
          } else {
            this.setState({ actions, selectedRows: selectedRowsCopy }, () => {
              this.sendAction(rstId, index + 1, nodes);
            });
          }
        },
      });
    }
  };

  stopActionsChain = () => {
    const { actions } = this.state;

    actions.count = '0';
    actions.title = '';
    actions.sending = false;

    this.setState({ actions });
  };

  fixIndexCellWidth = () => {
    const tableClassName = this.getTableClassName();

    const table = document.querySelector(`.${tableClassName} table`);

    if (table) {
      table.style.tableLayout = 'auto';

      const cells = document.querySelectorAll('.cell-index');
      const cellWidthes = [];

      cells.forEach((cell) => {
        cellWidthes.push(cell.offsetWidth);
      });

      let maxWidth = Math.max.apply(null, cellWidthes);

      const titleCell = document.querySelector('.rst-title-index');

      if (titleCell) titleCell.style.width = `${maxWidth}px`;
      table.style.tableLayout = 'fixed';
    }
  };

  getTableClassName() {
    const { tableGroupIndex, isEmbed, settings } = this.props;

    const tableClassName = isEmbed
      ? `trpls-table-${tableGroupIndex}-${settings.id}`
      : tableGroupIndex !== undefined
        ? `trpls-table-${tableGroupIndex}`
        : 'trpls-table';
    return tableClassName;
  };

  onRowsWeightChange = (isBold) => {
    const { tableId, rowBorderBold } = this.state;

    if (rowBorderBold !== isBold) this.setState({ rowBorderBold: isBold });

    const tableKey = `b.${tableId}`;

    if (isBold && !localStorage.getItem(tableKey)) {
      localStorage.setItem(tableKey, isBold);
    } else {
      localStorage.removeItem(tableKey);
    }
  };

  handleClickAllOnt = () => {
    this.setState((prevState) => {
      const newCount = prevState.clickCountForAllOnt + 1;
      return {
        clickCountForAllOnt: newCount,
        isHiddenAllOnt: newCount < 5,
      };
    });
  };

  handleChangePage = (event, newPage) => {
    this.setState({ isDataLoaded: false, rowsToShowPage: newPage + 1 }, () => {
      this.updateData(() => {
        this.fixIndexCellWidth();
      });
    });
  };

  handleChangeRowsPerPage = (event, rowsToShowPage) => {
    const setRowsPerPage = parseInt(event.target.value, 10);

    this.setState({ isDataLoaded: false, rowsToShow: setRowsPerPage, rowsToShowPage: 1 }, () => {
      this.updateData(() => {
        this.fixIndexCellWidth();
      });
    });
  };

  trplSaveDataImport = (nodeId, rst, val, isBool, tid) => {
    const { mode, ancestorId } = this.state;

    const rstId = Array.isArray(rst.id) ? rst.id[rst.id.length - 1] : rst.id;
    const value = isBool && !val ? false : val;

    const reqData = {
      persist: true,
      nodes: [],
    };

    let disableNotify = false;

    const trplObject = {
      pid: rstId,
      val: value,
    };

    if (rst.inverted) trplObject.inverted = rst.inverted;
    if (tid) trplObject.tid = tid;

    const trpls = rstId ? { [rstId]: [ trplObject ]} : {};

    if (mode === 'create') { //should also work for node creation with trpl
      // reqData.nodes.push({
      //   title: data.nodes[ancestorId].title,
      //   trpls,
      // });

      // if (!rstId) disableNotify = true;
      // reqData.cid = ancestorId;
    } else {
      reqData.nodes.push({
        id: nodeId,
        trpls,
      });
    }

    this.postWithData({
      url: `/rest/dataimport`,
      data: reqData,
      disableNotify,
      cb: (res) => {
        if (res._status === 'ok') {
          const { individuals } = this.state;

          const updatedIndividuals = produce(individuals, mutableInds => {
            mutableInds.trpls[nodeId][rstId][0][3] = val;
          });

          this.setState({
            individuals: updatedIndividuals
          });
          // const nodeId = mode === 'create' ? res.created_nodes[0] : this.state.ancestorId;

          // const { createNodeCb } = this.props;
          // if (createNodeCb && res.created_nodes[0]) {
          //   createNodeCb(res.created_nodes[0]);
          // }

          // if (cb) {
          //   cb(ancestorId);
          // }
        } else {
          //if (errorCb) errorCb(false, tid || rstId);
        }
      },
    });
  };

  render() {
    const {
      tbls,
      jels,
      setup,
      isEmbed,
      classes,
      settings,
      customSTitle,
      containerWidth,
      nodeToHighlight,
      smallHeadingBtns,
    } = this.props;

    const tableClassName = this.getTableClassName();

    const parentContainerWidth = containerWidth ? containerWidth.offsetWidth : null;

    const {
      init,
      account,
      actions,
      tableId,
      scrolled,
      tableMenu,
      rowsToShow,
      ancestorId,
      allOntNodes,
      individuals,
      tableLayout,
      searchValue,
      restrictions,
      isDataLoaded,
      selectedRows,
      tableSettings,
      trplFormModal,
      rowBorderBold,
      isHiddenAllOnt,
      filterRstModal,
      rowsToShowPage,
      rowsToShowSteps,
      isTableFiltered,
      trplFormModalOpened,
      renderPartsModalOpened,
      trplFormModalShowPids,
    } = this.state;

    const tableConceptData = individuals.nodes[settings.concept];
    const tableTitle = settings.title
      ? settings.title
      : tableConceptData === undefined
        ? ""
        : tableConceptData.labels !== undefined && tableConceptData.labels.en !== undefined && tableConceptData.labels.en.plural !== undefined
          ? tableConceptData.labels.en.plural
          : tableConceptData.title;

    const tableFormGroups =
      trplFormModal.groups !== undefined ? trplFormModal.groups : this.props.groups ? this.props.groups : [];

    const tableHeadingBtn = `${classes.btn} ${classes.btnEmpty} ${classes.tableHeadingBtn}`;

    const mainConceptTitle =
      tableConceptData
        ? tableConceptData.title
        : 'Concept title';

    let filtersCounter = 0;

    if (tableMenu.filters.trpls) {
      filtersCounter =
        tableMenu.filters.trpls
          .filter(isNotPlaceholderFilter)
          .length;
    }

    const noDataInTableNow = isDataLoaded && !individuals.query.length;

    return (
      <div
        style={{
          margin: isEmbed ? '1px' : '0 16px',
          position: 'relative',
          minHeight: `${!isDataLoaded ? (isEmbed || customSTitle ? '20px' : 'calc(100vh - 134px)') : ''}`,
        }}
      >
        {!isEmbed && actions.sending ? (
          <div className={classes.actionsStatus}>
            <span className={classes.actionsStatusText}>
              {`${actions.title}: ${actions.count}/${actions.totalCount} completed...`}
            </span>
            <span onClick={this.stopActionsChain} className={classes.actionsStatusCancel}>
              Cancel
            </span>
          </div>
        ) : null}

        <TrplFormFullScreenDialog
          isOpen={trplFormModalOpened}
          paperFullScreenStyles={classes.trplFormPaper}
        >
          <div className={classes.pb120}>
            <TrplForm
              tbls={tbls || []}
              tabs={trplFormModal.tabs}
              formId={trplFormModal.id}
              mode={trplFormModal.mode}
              title={trplFormModal.title}
              iId={trplFormModal.node.id}
              tableNodeId={settings.concept}
              show_pids={trplFormModalShowPids}
              updateParentData={this.updateData}
              closeModal={this.closeTrplFormModal}
              initialNodeId={trplFormModal.initialNodeId}
              paperFullScreenStyles={classes.tprlFormPaper}
              initialViewId={this.props.initialViewId || tableId}
              groups={isEmbed ? trplFormModal.groups : tableFormGroups}
              formConceptId={trplFormModal.id && jels.jelData[trplFormModal.id].concept}
              dataForShowPids={trplFormModalShowPids.length ? individuals : null}
            />
          </div>
        </TrplFormFullScreenDialog>

        <TrplRenderPartsModal
          data={individuals}
          modalData={trplFormModal}
          isOpen={renderPartsModalOpened}
          locations={setup.locations}
          onClose={() => {
            this.closeRenderPartsModal();
          }}
          updateDataOnCreateTrpl={() => {
            this.closeRenderPartsModal();
          }}
        />

        <div className={`${classes.alignCenter} ${classes.spaceBetweenEnd} ${isEmbed ? '' : classes.mt20}`} style={{ marginBottom: isEmbed ? '' : '8px', overflow: 'hidden' }}>
          {customSTitle ? <span className={`${classes.mr20} ${classes.alignCenter}`} style={{ fontSize: 16, fontWeight: 550, height: '40px' }}>{customSTitle}</span> : null}
            {(isEmbed && settings.show_index) || !isEmbed ? (
              <div className={`${classes.fw} ${classes.mr20} ${classes.spaceBetween}`} style={{ height: '40px' }}>
                <div className={`${classes.alignCenter}`}>
                  {!isEmbed ? (
                    <React.Fragment>
                    <a
                      href={settings.id ? `/frm?id=${settings.id}` : `/tbl?id=${settings.concept}`}
                      className={classes.tableTitle}
                    >
                      <h3>{tableTitle}</h3>
                    </a>

                    {(tableSettings.show_create_node === undefined || tableSettings.show_create_node) && (
                      <Button
                        size="small"
                        disabled={!isDataLoaded}
                        onClick={() =>
                          this.openTrplFormFull({
                            node: { id: settings.concept },
                            mode: 'create',
                          })
                        }
                        className={`${tableHeadingBtn} ${classes.tableHeadingBtnMain}`}
                        style={{ transform: smallHeadingBtns ? 'scale(0.9)' : 'none' }}
                      >
                        <Add className={classes.tableHeadingBtnIcon} style={{ fontSize: 13, color: '#fff', padding: '4px', borderRadius: '10px', backgroundColor: '#121617' }}/>{' '}
                        <span className={classes.tableHeadingBtnText}>{mainConceptTitle}</span>
                      </Button>
                    )}

                    <Popover
                      id="filters-popover"
                      anchorEl={tableMenu.filters.el}
                      open={Boolean(tableMenu.filters.el)}
                      PaperProps={{
                        className: classes.glassBG,
                        style: {
                          overflow: 'visible',
                          marginTop: '10px',
                        },
                      }}
                      onClose={() => this.togglePopover(null, 'filters')}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                      disableScrollLock={true}
                    >
                      <Filters
                        ancestor={settings.concept}
                        callbacks={{
                          onFilterBtnClick: this.onFilterBtnClick,
                          setFiltersToParentState: this.setFiltersToState,
                          onFiltersSearchNodeCb: this.onFilterSearchElemClick,
                        }}
                        filterBtnText="Filter"
                        filterByNodeTitle={true}
                        nodes={individuals.nodes}
                        initialSearchValue={searchValue}
                        rstDataMap={tableMenu.filters.rstDataMap}
                        loaded={isTableFiltered}
                        initialFilters={tableMenu.filters.initialFilters}
                      />
                    </Popover>

                    <Button
                      size="small"
                      disabled={!isDataLoaded}
                      aria-describedby="filters-popover"
                      className={`filters-popover-btn ${tableHeadingBtn} ${(filtersCounter || Boolean(tableMenu.filters.el)) ? classes.tableMenuSelectedBtn : ''}`}
                      style={{ transform: smallHeadingBtns ? 'scale(0.9)' : 'none' }}
                      onClick={(e) => {
                        this.togglePopover(e.currentTarget, 'filters');
                      }}
                    >
                      <FilterListOutlined className={classes.tableHeadingBtnIcon} />{' '}
                      <span className={classes.tableHeadingBtnText}>
                        {!filtersCounter ? 'Filter' : `Filters: ${filtersCounter}`}
                      </span>
                    </Button>

                    <Popover
                      id="sorters-popover"
                      anchorEl={tableMenu.sorter.el}
                      open={Boolean(tableMenu.sorter.el)}
                      PaperProps={{
                        className: classes.glassBG,
                        style: {
                          overflow: 'visible',
                          marginTop: '10px',
                        },
                      }}
                      onClose={() => this.togglePopover(null, 'sorter')}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                      disableScrollLock={true}
                    >
                      <Sorters
                        initialSorters={tableMenu.sorter.data}
                        // TODO why do sorters use same with filters data
                        rstDataMap={tableMenu.filters.rstDataMap}
                        callbacks={{
                          setSorters: this.onSorterClick,
                          onAddInitialRst: () => {
                            // add forceUpdate for re-render parent on add initial rst
                            // for right positioning of popover

                            this.forceUpdate();
                          },
                        }}
                      />
                    </Popover>

                    <Button
                      size="small"
                      disabled={!isDataLoaded}
                      className={`sorters-popover-btn ${tableHeadingBtn} ${
                        (tableMenu.sorter.data.sort_pid || Boolean(tableMenu.sorter.el)) ? classes.tableMenuSelectedBtn : ''
                      }`}
                      style={{ transform: smallHeadingBtns ? 'scale(0.9)' : 'none' }}
                      aria-describedby="sorter-popover"
                      onClick={(e) => this.togglePopover(e.currentTarget, 'sorter')}
                    >
                      <SortByAlpha className={classes.tableHeadingBtnIcon} />
                      <span className={classes.tableHeadingBtnText}>
                        {!tableMenu.sorter.data.sort_pid ? 'Sort' : `Sorted by: ${tableMenu.sorter.data.sort_pid ? '1' : ''}`}
                      </span>
                    </Button>

                    <Popover
                      id="hidecolumn-popover"
                      anchorEl={tableMenu.hideColumn.el}
                      open={Boolean(tableMenu.hideColumn.el)}
                      PaperProps={{
                        className: classes.glassBG,
                        style: {
                          marginTop: '10px',
                        },
                      }}
                      onClose={() => this.togglePopover(null, 'hideColumn')}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                      }}
                      disableScrollLock={true}
                    >
                      <div className={classes.column} style={{ width: 'fit-content', minWidth: '200px', paddingTop: '4px' }}>
                        <div className={classes.hideColumnMenuRstContainer}>
                          {restrictions.map((rst, rstIndex) => {
                            const columnTitle = getColumnTitle(rst);
                            const rstChainId = getColumnId(rst);

                            const switched = tableMenu.hideColumn.data.includes(rstChainId);

                            return (
                              <div key={rstIndex} className={classes.hideColumnRow} onClick={(e) => {
                                this.toggleColumn(rstChainId);
                              }}>
                                <div className={classes.mr10}>
                                  <Switcher switched={!switched}/>
                                </div>{' '}
                                <div className={classes.alignCenter}>
                                  {columnTitle} {'\u200B'}
                                  {account && account.access_level > 1 ?
                                    <span style={{ fontSize: '10px' }}>
                                      {`${'[' + rstChainId + ']'}`}
                                    </span>
                                  : null}
                                </div>
                              </div>
                            );
                          })}
                        </div>

                        <div style={{ borderTop: '1px solid #eeecf8' }} className={classes.hideColumnMenuBtns}>
                          <button
                            className={classes.hideColumnMenuBtn}
                            style={{
                              marginRight: '20px',
                            }}
                            onClick={() => this.toggleAllColumns(true)}
                          >
                            Hide all
                          </button>

                          <button className={classes.hideColumnMenuBtn} onClick={() => this.toggleAllColumns(false)}>
                            Show all
                          </button>
                        </div>
                      </div>
                    </Popover>

                    <Button
                      size="small"
                      disabled={!isDataLoaded}
                      className={`${tableHeadingBtn} ${(tableMenu.hideColumn.data.length || Boolean(tableMenu.hideColumn.el)) ? classes.tableMenuSelectedBtn : ''}`}
                      style={{ transform: smallHeadingBtns ? 'scale(0.9)' : 'none' }}
                      aria-describedby="hidecolumn-popover"
                      onClick={(e) => this.togglePopover(e.currentTarget, 'hideColumn')}
                    >
                      <VisibilityOffOutlined
                        className={classes.tableHeadingBtnIcon}
                      />{' '}
                      <span className={classes.tableHeadingBtnText}>
                        {tableMenu.hideColumn.data.length ? `Hidden: ${tableMenu.hideColumn.data.length}` : 'Hide column'}
                      </span>
                    </Button>
                    </React.Fragment>
                  ) : null}

                  

                  <Popover
                    id="export-popover"
                    anchorEl={tableMenu.export.el}
                    open={Boolean(tableMenu.export.el)}
                    PaperProps={{
                      className: classes.glassBG,
                      style: {
                        marginTop: '10px',
                      },
                    }}
                    onClose={() => this.togglePopover(null, 'export')}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'center',
                    }}
                    disableScrollLock={true}
                  >
                    <div className={classes.hideColumnMenuBtns}>
                      <a className="download-tbl">
                        <button
                          className={classes.hideColumnMenuBtn}
                          onClick={() => this.onExportClick('xls')}
                          style={{
                            marginRight: '20px',
                          }}
                        >
                          XLS
                        </button>

                        <button
                          className={classes.hideColumnMenuBtn}
                          onClick={() => this.onExportClick('csv')}
                        >
                          CSV
                        </button>
                      </a>
                    </div>
                  </Popover>

                  {tableSettings.show_export &&
                    <Button
                      size="small"
                      disabled={!isDataLoaded}
                      className={tableHeadingBtn}
                      aria-describedby="export-popover"
                      onClick={(e) => this.togglePopover(e.currentTarget, 'export')}
                    >
                      <CloudDownloadOutlined className={classes.tableHeadingBtnIcon} />{' '}
                      <span className={classes.tableHeadingBtnText}>Export</span>
                    </Button>
                  }

                  <Popover
                    id="actions-popover"
                    anchorEl={tableMenu.actions.el}
                    open={Boolean(tableMenu.actions.el)}
                    PaperProps={{
                      className: classes.glassBG,
                      style: {
                        marginTop: '10px',
                      },
                    }}
                    onClose={() => this.togglePopover(null, 'actions')}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'center',
                    }}
                    disableScrollLock={true}
                  >
                    <div className={`${classes.p10} ${classes.column}`}>
                      {actions.variants.map((action, actionIndex) => (
                        <div key={action.id} style={{ marginBottom: '5px' }}>
                          <AnimatedButton
                            key={action.id}
                            onClick={() => {
                              this.doActions(action.id, action.title);
                            }}
                          >
                            <span>{action.title}</span>
                          </AnimatedButton>
                        </div>
                      ))}

                      {actions.variants.length === 0 ? <span>No actions available :(</span> : null}
                    </div>
                  </Popover>

                  {actions.variants.length !== 0 ?
                    <div>
                      {!selectedRows.length ? (
                        <ArrowTooltipCss placement="bottom" text="Select a row to do action">
                          <Button
                            size="small"
                            disabled={!isDataLoaded}
                            className={tableHeadingBtn}
                            style={{ transform: smallHeadingBtns ? 'scale(0.9)' : 'none' }}
                          >
                            <KeyboardArrowDownOutlined className={classes.tableHeadingBtnIcon} />{' '}
                            <span className={classes.tableHeadingBtnText}>Action</span>
                          </Button>
                        </ArrowTooltipCss>
                      ) : (
                        <Button
                          size="small"
                          aria-describedby="actions-popover"
                          onClick={(e) => {
                            this.togglePopover(this.actionBtn, 'actions');
                          }}
                          disabled={!isDataLoaded}
                          ref={(actionBtn) => (this.actionBtn = actionBtn)}
                          className={`${tableHeadingBtn} ${classes.tableMenuSelectedBtn}`}
                          style={{ transform: smallHeadingBtns ? 'scale(0.9)' : 'none' }}
                        >
                          {tableMenu.actions.el ? (
                            <KeyboardArrowUpOutlined className={classes.tableHeadingBtnIcon} />
                          ) : (
                            <KeyboardArrowDownOutlined className={classes.tableHeadingBtnIcon} />
                          )}{' '}
                          <span className={classes.tableHeadingBtnText}>{`Rows selected: ${selectedRows.length}`}</span>
                        </Button>
                      )}
                    </div>
                  : null}
                  {tableId && !customSTitle ?
                    <div className={`${classes.alignCenter}`} style={{ opacity: isDataLoaded ? 1 : 0.5 }}>
                      <ArrowTooltipCss placement="bottom" text="Rows border weight">
                        <div
                          className={`${classes.pointer} ${classes.alignJustifyCenter} ${classes.tableHeadingSettingsBtn}`}
                          style={{
                            outline: '1px solid #cbd1e8',
                            background: rowBorderBold ? '#ffff' : '',
                            transform: smallHeadingBtns ? 'scale(0.9)' : 'none',
                          }}
                          onClick={() => this.onRowsWeightChange(!rowBorderBold)}
                        >
                          <DragHandleOutlined
                            style={{ fontSize: '17px', marginLeft: '1px' }}
                          />
                        </div>
                      </ArrowTooltipCss>
                    </div>
                  : null}
                </div>
                
                <div className={classes.alignCenter}>
                  {account && account.access_level > 1 && tableConceptData && setup.id && (tableConceptData.ontology === setup.id) ?
                    <div onClick={this.handleClickAllOnt} className={`${classes.mr20} ${classes.ml10}`} style={{ minWidth: '80px', minHeight: '17px', marginTop: '2px', maxWidth: '200px' }}>
                      {isHiddenAllOnt ? null :
                        <div className={`${classes.alignCenter}`}>
                          <div
                            className={classes.mr10}
                            onClick={() => {
                              this.setState((prevState) => ({ allOntNodes: !prevState.allOntNodes }),
                                () => {
                                  this.updateData();
                                }
                              );
                            }}
                          >
                            <Switcher switched={allOntNodes}/>
                          </div>
                          <span className={classes.nowrap}>
                            All ontologies
                          </span>
                        </div>
                      }
                    </div>
                  : null}

                  <div
                    style={{
                      opacity: isDataLoaded ? 1 : 0,
                      transition: 'opacity 0.6s ease-out',
                    }}
                  >
                    {((individuals.total_query > rowsToShow) || (individuals.total_query > 50) ) ?
                      <TablePagination
                        component="div"
                        count={individuals.total_query}
                        page={rowsToShowPage - 1}
                        onPageChange={this.handleChangePage}
                        rowsPerPage={rowsToShow}
                        rowsPerPageOptions={rowsToShowSteps}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                        labelRowsPerPage={"Rows/page"}
                        sx={{
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                          ".MuiTablePagination-toolbar": {
                            minHeight: '30px',
                            padding: 0,
                          },
                          ".MuiTablePagination-selectLabel": {
                            fontSize: '12px',
                            display: isEmbed ? 'none' : '',
                            '@media (max-width: 1300px)': {
                              display: 'none',
                            }
                          },
                          ".MuiTablePagination-displayedRows": {
                            margin: 0,
                            fontSize: '12px',
                            '@media (max-width: 1300px)': {
                              display: 'none',
                            }
                          },
                          ".MuiInputBase-input": {
                            padding: '2px 8px',
                            margin: '0 3px',
                            borderRadius: '20px !important',
                            height: '26px !important',
                          },
                          ".MuiSelect-select": {
                            padding: '2px 8px',
                            margin: '0 3px',
                            display: isEmbed ? 'none' : 'flex',
                            opacity: 0,
                            animation: 'fadeIn 0.4s ease-out forwards',
                            animationDelay: '0.4s',
                            ".MuiSelect-icon": {
                              marginRight: '8px',
                            },
                          },
                          ".MuiInputBase-root": {
                            margin: 0,
                            padding: '2px',
                            '@media (max-width: 1300px)': {
                              display: 'none',
                            }
                          },
                          ".MuiTablePagination-actions": {
                            marginLeft: '10px',
                            "& button": {
                              padding: '5px',
                              minWidth: '20px',
                            },
                          },
                          '@keyframes fadeIn': {
                            from: { opacity: 0 },
                            to: { opacity: 1 }
                          },
                        }}
                      />
                    : null}
                  </div>
                </div>
              </div>
            ) : null}
        </div>

        <Paper
          className={`${tableClassName} ${classes.relative}`}
          style={{ minHeight: 'inherit', overflow: 'hidden' }} 
          sx={{ background: 'transparent', boxShadow: 'none', overflow: 'hidden', borderRadius: 0, margin: 0 }}
        >
          <div
            className={`trpls-table-container ${classes.tableContainer}`}
            style={{
              position: 'static',
              maxHeight: `${(isEmbed || customSTitle)? '' : 'calc(100vh - 134px)'}`,
              paddingBottom: isEmbed ? '' : '8px',
              borderRadius: isEmbed ? '' : '8px',
              overflow: 'auto', // isEmbed ? 'hidden' : 'auto',
              border: isDataLoaded ? '1px solid rgb(227 233 243)' : '',
            }}
            ref={(mainContainer) => (this.mainContainer = mainContainer)}
          >
            <div className={classes.gradientOverlay} style={{ borderRadius: isEmbed ? '' : '8px', background: `#ffff` }}></div>
            <div className={classes.gradientOverlay} style={{ opacity: noDataInTableNow ? 0.4 : 0.6, borderRadius: isEmbed ? '' : '8px', background: `linear-gradient(to top, ${getNodeColor(settings.concept)}, rgb(212 204 249))` }}></div>

            {!isDataLoaded && !isEmbed  ? (
              <div className={classes.tableLoaderOverlay} style={{ borderRadius: '8px', height: isEmbed ? '' : 'calc(100vh - 134px)' }}>
                <LoaderNew />
              </div>
            ) : null}

            {!init ? (
              <Table
                style={{
                  tableLayout,
                  left: 0,//'-1px',
                  zoom: 'unset',
                  transform: 'none',
                  willChange: 'auto',
                  imageRendering: 'auto',
                  position: 'relative',
                  borderBottom: '1px solid #ffffff',
                  overflow: isEmbed ? 'hidden' : 'auto',
                  //borderSpacing: rowBorderBold ? '0 5px' : '0 1px',
                  borderCollapse: 'collapse',
                  //top: 0,//rowBorderBold ? '-5px' : '-1px',
                  WebkitFontSmoothing: 'subpixel-antialiased',
                  MozOsxFontSmoothing: 'auto',
                  textRendering: 'optimizeLegibility',
                }}
              >
                <TableBody>
                  <TrplsTableHeadRow
                    setup={setup}
                    account={account}
                    tableId={tableId}
                    isEmbed={isEmbed}
                    classes={classes}
                    scrolled={scrolled}
                    settings={settings}
                    tableMenu={tableMenu}
                    ancestorId={ancestorId}
                    searchValue={searchValue}
                    individuals={individuals}
                    allOntNodes={allOntNodes}
                    restrictions={restrictions}
                    isDataLoaded={isDataLoaded}
                    selectedRows={selectedRows}
                    selectNode={this.selectNode}
                    rowBorderBold={rowBorderBold}
                    setSorters={this.onSorterClick}
                    filterRstModal={filterRstModal}
                    toggleColumn={this.toggleColumn}
                    togglePopover={this.togglePopover}
                    initialSorters={tableMenu.sorter.data}
                    hideColumns={tableMenu.hideColumn.data}
                    onFilterBtnClick={this.onFilterBtnClick}
                    setFiltersToState={this.setFiltersToState}
                    rstAddFilterClick={this.rstAddFilterClick}
                    onFilterSearchElemClick={this.onFilterSearchElemClick}
                  />

                  {individuals.query ? individuals.query.map((nodeId, index) => {
                    if (index < rowsToShow) {
                      const newTrpls = getTransformedTrplsArrayToObj(individuals.trpls, nodeId, trplsParamsTable);

                      const isNew = individuals.nodes && individuals.nodes[nodeId] && individuals.nodes[nodeId].isNew;//find out why it needed
                      if (!individuals.nodes[nodeId]) console.log('not found node is', nodeId, individuals.nodes);

                      const nodeRulesKey = individuals.rights && individuals.rights.nodes[nodeId];
                      const nodeRightsRules = individuals.rights && individuals.rights.rules[nodeRulesKey];
                      const highlightRow = nodeToHighlight ? ((nodeToHighlight.length && nodeToHighlight.includes(+nodeId)) ? true : false) : null;

                      return (
                        <TrplsTableRow
                          key={nodeId}
                          isNew={isNew}
                          nodeId={nodeId}
                          rowIndex={index}
                          trpls={newTrpls}
                          tableId={tableId}
                          isEmbed={isEmbed}
                          account={account}
                          classes={classes}
                          settings={settings}
                          rowsToShow={rowsToShow}
                          ancestorId={ancestorId}
                          individuals={individuals}
                          nodesParams={nodesParams}
                          allOntNodes={allOntNodes}
                          highlightRow={highlightRow}
                          selectedRows={selectedRows}
                          restrictions={restrictions}
                          selectNode={this.selectNode}
                          rowBorderBold={rowBorderBold}
                          rowsToShowPage={rowsToShowPage}
                          whiteRows={this.props.whiteRows}
                          nodeRightsRules={nodeRightsRules}
                          hideColumns={tableMenu.hideColumn.data}
                          openTrplFormFull={this.openTrplFormFull}
                          onRstTypeBtnClick={this.onRstTypeBtnClick}
                          trplSaveDataImport={this.trplSaveDataImport}
                          openTrplFormWithRst={this.openTrplFormWithRst}
                          onNodeRemoveBtnClick={this.onNodeRemoveBtnClick}
                        />
                      );
                    }

                    return null;
                  }) : null}
                </TableBody>
              </Table>
            ) : null}

            {noDataInTableNow ? (
              <div className={classes.emptyTableText}>Nothing to show</div>
            ) : null}
          </div>
        </Paper>
      </div>
    );
  }
};

export default connect((state) => ({
  jels: state.jels,
  setup: state.meta.setup,
  account: state.meta.account,
}), { updateJelsFromGetView, getJelData })(withStyles(styles)(TrplsTable));
